export const LAYERS_PARAMETERS_UPDATED_EVENT_TYPE = 'layers.param.update'
export const CLEAR_OL_CACHE_EVENT_TYPE = 'ol.cache.clear'
export const MAP_DATABASE_UPDATED_EVENT_TYPE = 'database.map'
export const COLOR_CHANGE_EVENT_TYPE  = 'color.update'
export const ONLINE_CHANGE_EVENT_TYPE = 'online.update'
export const PROJECTION_CHANGE_EVENT_TYPE = 'projection.update'
export const CANCEL_EDITION_MODE_EVENT = 'editionMode.cancel'
export const SAVE_EDITION_MODE_EVENT = 'editionMode.save'
export const REMOVE_ETA_EVENT = 'remove.eta'
export const NOTIFICATION_LOADING_EVENT = 'notification.loading'
export const NOTIFICATION_AREA_STATUS_CHANGE_EVENT = 'notification.area.status.change'
export const ULHYSSES_DATABASE_UPDATED_EVENT_TYPE = 'database.ulhysses';

export const DELETE_TILE_CACHE_EVENT = 'map.chache.clear'

export const SEND_MESSAGE_EVENT_TYPE = 'msg.ws.send'
export const ULH_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.ulh'
export const AIS_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.ais'
export const DBMANAGER_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.dbm'
export const ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.mob'
export const MAPDBVERSION_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.dbVersion'
export const ONLINE_MESSAGE_CHANGE_EVENT_TYPE = 'msg.ws.online'
export const ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE = 'msg.ws.notif'

export const OPEN_MODULE_EVENT = 'msg.open.module'
export const UPDATE_ETA_EVENT = 'msg.ais.updateEta'
export const DRAW_ETA_EVENT = 'draw.eta'
export const CANCEL_ETA_CONTROL_EVENT = 'eta.control.cancel'
export const ACTIVE_ETA_CONTROL_EVENT = 'eta.control.active'

export const ACTIVE_SHIPPLACEMENT_ATTACHED_FILES_EVENT = 'shipplacement.attachedFiles.active'
export const INACTIVE_SHIPPLACEMENT_ATTACHED_FILES_EVENT = 'shipplacement.attachedFiles.inactive'
export const REFRESH_SHIP_PLACEMENT = 'shipplacement.attachedFiled.refresh'